import React from 'react';
import Drawing from "./Drawing";
import LiveResult from "./LiveResult";
import bgResult from "../../../../assets/images/live/live-result-night.png";

const ResultNight = (props) => {
    return (
        <>
            <div className="lay1">
                <Drawing {...props}/>
            </div>
            <div className="lay2" style={{
                backgroundImage: `url(${bgResult})`
            }}>
                <LiveResult {...props}/>
            </div>
        </>
    );
};

export default ResultNight;